var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "field" }, [
        _c(
          "label",
          {
            staticClass: "label",
            class: { "has-text-danger": _vm.errors.has("nombre", "serie") },
          },
          [_vm._v("Nombre del evento")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.nombre,
                expression: "model.nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("nombre", "serie") },
            attrs: {
              name: "nombre",
              placeholder: "Requerido",
              "data-vv-scope": "serie",
            },
            domProps: { value: _vm.model.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "nombre", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("nombre", "serie")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("nombre", "serie"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("¿Que acción ejecuta el evento?"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.accionesDisponibles, function (accion) {
            return _c("div", { key: accion.id, staticClass: "control" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addAccion(accion)
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              ),
              _vm._v("  " + _vm._s(accion.nombre) + "\n        "),
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.incompatibilidades, function (inc, index) {
            return _c("p", { key: index, staticClass: "help is-danger" }, [
              _c("i", { staticClass: "fas fa-times-circle" }),
              _vm._v(
                ' "' +
                  _vm._s(inc.queAccion) +
                  '" es incompatible con "' +
                  _vm._s(inc.cualAccion) +
                  '"'
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.model.accion, function (accion, index) {
        return _c("parametros", {
          key: accion.specialKey,
          ref: "param-" + accion.id + `-${index}`,
          refInFor: true,
          attrs: { accion: accion },
          on: {
            delete: function ($event) {
              return _vm.deleteAccion(accion.specialKey)
            },
          },
        })
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "notification" },
            [
              _c("h1", { staticClass: "title is-5" }, [
                _vm._v("Estados Iniciales"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "subtitle is-7" }, [
                _vm._v("Seleccione el o los estados iniciales"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.serieDocumental.estados, function (nombreEstado, key) {
                return _c(
                  "div",
                  { key: key, staticClass: "field" },
                  [
                    _c(
                      "b-checkbox",
                      {
                        attrs: { "native-value": key },
                        model: {
                          value: _vm.model.estadosIniciales,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "estadosIniciales", $$v)
                          },
                          expression: "model.estadosIniciales",
                        },
                      },
                      [_vm._v(_vm._s(nombreEstado))]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "notification" },
            [
              _c("h1", { staticClass: "title is-5" }, [_vm._v("Estado Final")]),
              _vm._v(" "),
              _c("p", { staticClass: "subtitle is-7" }, [
                _vm._v("Seleccione aquí el estado final"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": null },
                      model: {
                        value: _vm.model.estadoFinal,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "estadoFinal", $$v)
                        },
                        expression: "model.estadoFinal",
                      },
                    },
                    [_c("i", [_vm._v("Mantener el estado inicial")])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.serieDocumental.estados, function (nombreEstado, key) {
                return _c(
                  "div",
                  { key: key, staticClass: "field" },
                  [
                    _c(
                      "b-radio",
                      {
                        attrs: { "native-value": key },
                        model: {
                          value: _vm.model.estadoFinal,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "estadoFinal", $$v)
                          },
                          expression: "model.estadoFinal",
                        },
                      },
                      [_vm._v(_vm._s(nombreEstado))]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.areasDisponibles.length > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c(
                  "b-switch",
                  {
                    model: {
                      value: _vm.habilitarRestringirAreas,
                      callback: function ($$v) {
                        _vm.habilitarRestringirAreas = $$v
                      },
                      expression: "habilitarRestringirAreas",
                    },
                  },
                  [
                    _c("label", { staticClass: "label", attrs: { for: "" } }, [
                      _vm._v("Habilitar restringir por areas"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.habilitarRestringirAreas
              ? _c("div", [
                  _vm.areasDisponibles.length
                    ? _c(
                        "div",
                        { staticClass: "block my-4" },
                        _vm._l(_vm.areasDisponibles, function (area) {
                          return _c(
                            "b-checkbox",
                            {
                              key: area.id,
                              attrs: { "native-value": area.id },
                              model: {
                                value: _vm.model.areasSeleccionadas,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "areasSeleccionadas", $$v)
                                },
                                expression: "model.areasSeleccionadas",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(area.nombre) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm.model.areasSeleccionadas.length == 0
                      ? _c("p", {}, [
                          _c("i", {
                            staticClass:
                              "fas fa-info-circle fa-lg has-text-link",
                          }),
                          _vm._v(
                            " No ha seleccionado ningun area en particular. Por lo tanto, todas las areas e individuos con privilegios pueden ejecutar el evento\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Habilitar restringir por areas"),
            ]),
            _vm._v(" "),
            _vm._m(2),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "a",
          { staticClass: "button is-primary", on: { click: _vm.addEvento } },
          [_c("i", { staticClass: "fas fa-plus" }), _vm._v(" Agregar")]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Curso de los estados")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-narrow is-hidden-touch" }, [
      _c("br"),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-5 is-marginless" }, [
        _c("i", { staticClass: "fas fa-arrow-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "control" }, [
      _c("i", { staticClass: "fas fa-info-circle fa-lg has-text-link" }),
      _vm._v(
        " La organización no cuenta con areas para restringir las acciones por areas\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }